import create from './createAction'

export const SUMMARY_PAGE_ERROR = 'SUMMARY_PAGE_ERROR'
export const PAYMENT_PAGE_ERROR = 'PAYMENT_PAGE_ERROR'

export const onSummaryPageError = create(SUMMARY_PAGE_ERROR)
export const onPaymentPageError = create(PAYMENT_PAGE_ERROR)
